import { render, staticRenderFns } from "./activityUpdate.vue?vue&type=template&id=82ca4ed0&scoped=true&"
import script from "./activityUpdate.vue?vue&type=script&lang=js&"
export * from "./activityUpdate.vue?vue&type=script&lang=js&"
import style0 from "./activityUpdate.vue?vue&type=style&index=0&id=82ca4ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ca4ed0",
  null
  
)

export default component.exports